import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Paul Zellmer

 Description:
*/
import { fromJS } from 'immutable';
import NavigationItemRecord from '../../../records/NavigationItemRecord';
import NavigationBarRecord from '../../../records/NavigationBarRecord';
import NavigationMenuColumnSectionRecord from '../../../records/NavigationMenuColumnSectionRecord';
import NavigationMenuTileRecord from '../../../records/NavigationMenuTileRecord';
import MastheadBarButtonRecord from '../../../records/MastheadBarButtonRecord';
var displayTypeRegex = /data-display-type="(.*?)"/;
var deviceFeatureRegex = /data-device-feature="(.*?)"/;

var getDisplayType = function getDisplayType(link) {
  var displayType;

  if (link.samlLinkAttributesAsString) {
    displayType = displayTypeRegex.exec(link.samlLinkAttributesAsString)[1];
  } else if (link.nonSamlLinkAttributesAsString) {
    displayType = displayTypeRegex.exec(link.nonSamlLinkAttributesAsString)[1];
  } else {
    displayType = 'browser';
  }

  return displayType;
};

var getDeviceFeature = function getDeviceFeature(link) {
  var match;

  if (link.samlLinkAttributesAsString) {
    match = deviceFeatureRegex.exec(link.samlLinkAttributesAsString);
  } else if (link.nonSamlLinkAttributesAsString) {
    match = deviceFeatureRegex.exec(link.nonSamlLinkAttributesAsString);
  }

  return match ? match[1] : undefined;
};

var getFilteredLinks = function getFilteredLinks(_ref) {
  var applicableLinks = _ref.applicableLinks,
      applicableLinksSet = _ref.applicableLinksSet;
  return (// Filter out unused top-level links
    applicableLinks.filter(function (link) {
      return applicableLinksSet.indexOf(link.linkId) >= 0;
    })
  );
};

var getNavigationObject = function getNavigationObject(link, linkConfigMap) {
  var linkConfig = linkConfigMap[link.linkId];

  if (!linkConfig) {
    return {
      linkId: link.linkId,
      linkName: link.linkName
    };
  }

  var navigationUrl = linkConfig.navigationUrl,
      derivedUrl = linkConfig.derivedUrl,
      samlNavigation = linkConfig.samlNavigation,
      secureSessionUrl = linkConfig.secureSessionUrl;
  var displayType = getDisplayType(linkConfig);
  var deviceFeature = getDeviceFeature(linkConfig);
  var bevName = link.anchorTagAttributes ? link.anchorTagAttributes['data-bev-name'] : undefined;
  return {
    navigationUrl: navigationUrl || derivedUrl,
    linkId: link.linkId,
    linkName: link.linkName,
    deviceFeature: deviceFeature,
    displayType: displayType,
    samlNavigation: samlNavigation,
    secureSessionUrl: secureSessionUrl,
    bevName: bevName,
    anchorTagAttributes: link.anchorTagAttributes
  };
};

var getNavigationBarItems = function getNavigationBarItems(navigationPayload) {
  var navigationBarItems = [];
  var headerLinks = navigationPayload.profileMainMenuLinkMap.HEADER_LINKS;
  var applicableLinksSet = headerLinks.applicableLinksSet,
      linkConfigMap = headerLinks.linkConfigMap;
  var links = getFilteredLinks(headerLinks);
  links.forEach(function (menuLink) {
    var subMenuColumns = [];
    var navigationBarItem = {
      id: menuLink.linkId,
      containerId: menuLink.linkId,
      label: menuLink.linkName,
      hasMenu: !!menuLink.subLevelHierarchyList,
      bevName: menuLink.anchorTagAttributes ? menuLink.anchorTagAttributes['data-bev-name'] : undefined
    };
    var subMenuLinks;
    var columnLinks;
    var columnTiles;

    if (navigationBarItem.hasMenu) {
      subMenuLinks = getFilteredLinks({
        applicableLinks: menuLink.subLevelHierarchyList,
        applicableLinksSet: applicableLinksSet
      });
      subMenuLinks.forEach(function (linkColumn) {
        var subMenuLinks = [];
        var isTile = !(linkColumn.subLevelHierarchyList && linkColumn.subLevelHierarchyList[0] && linkColumn.subLevelHierarchyList[0].subLevelHierarchyList);

        if (isTile) {
          columnTiles = getFilteredLinks({
            applicableLinks: linkColumn.subLevelHierarchyList,
            applicableLinksSet: applicableLinksSet
          });
          columnTiles.forEach(function (linkTile) {
            var linkItem = getNavigationObject(linkTile, linkConfigMap);
            subMenuLinks.push(new NavigationMenuTileRecord({
              'iconName': linkTile.listItemClassName.replace('h-', ''),
              'link': new NavigationItemRecord(linkItem),
              'body': linkTile.linkDescription
            }));
          });
        } else {
          columnLinks = getFilteredLinks({
            applicableLinks: linkColumn.subLevelHierarchyList,
            applicableLinksSet: applicableLinksSet
          });
          columnLinks.forEach(function (columnSection) {
            var subSectionLinks = [];
            var filteredColumnSections = getFilteredLinks({
              applicableLinks: columnSection.subLevelHierarchyList,
              applicableLinksSet: applicableLinksSet
            });
            filteredColumnSections.forEach(function (link) {
              var linkItem = getNavigationObject(link, linkConfigMap);
              subSectionLinks.push(new NavigationItemRecord(linkItem));
            });
            subMenuLinks.push(new NavigationMenuColumnSectionRecord({
              'iconName': columnSection.listItemClassName.replace('h-', ''),
              'title': columnSection.linkName,
              'links': subSectionLinks
            }));
          });
        }

        subMenuColumns.push(subMenuLinks);
      });
      navigationBarItem.subMenuLinks = subMenuColumns;
      navigationBarItem.fitPage = !menuLink.anchorTagAttributesAsString.includes('mwf-app-nav-1col');
    } else {
      // Define navigation item when navigationBarItem does not have a sub-menu (Brokerage)
      var linkItem = getNavigationObject(menuLink, linkConfigMap);
      navigationBarItem.subMenuLinks = [[{
        link: new NavigationItemRecord(linkItem)
      }]];
    }

    navigationBarItems.push(new NavigationBarRecord(navigationBarItem));
  });
  return navigationBarItems;
};

var getProfileBarItems = function getProfileBarItems(navigationPayload) {
  var profileBarItems = [];
  var headerLinks = navigationPayload.profileMainMenuLinkMap.PROFILE_HEADER_LINKS;
  var applicableLinksSet = headerLinks.applicableLinksSet,
      linkConfigMap = headerLinks.linkConfigMap;
  var filteredMenus = getFilteredLinks(headerLinks);
  filteredMenus.forEach(function (menu) {
    var profileBarButton;

    if (menu.subLevelHierarchyList) {
      var filteredMenuSections = getFilteredLinks({
        applicableLinks: menu.subLevelHierarchyList,
        applicableLinksSet: applicableLinksSet
      });
      var menuSections = [];
      filteredMenuSections.forEach(function (menuSection) {
        var profileMenuSection;

        if (menuSection.subLevelHierarchyList) {
          var filteredMenuSubSections = getFilteredLinks({
            applicableLinks: menuSection.subLevelHierarchyList,
            applicableLinksSet: applicableLinksSet
          });
          var menuSubSection = [];
          filteredMenuSubSections.forEach(function (subSection) {
            var filteredSection = getFilteredLinks({
              applicableLinks: subSection.subLevelHierarchyList,
              applicableLinksSet: applicableLinksSet
            });
            var linkList = [];
            filteredSection.forEach(function (link) {
              var configuredLink = new NavigationItemRecord(getNavigationObject(link, linkConfigMap));
              linkList.push(configuredLink);
            });
            var section = {
              linkId: subSection.linkId,
              linkName: subSection.linkName,
              bevName: subSection.anchorTagAttributes ? subSection.anchorTagAttributes['data-bev-name'] : undefined,
              subMenuLinks: fromJS(linkList)
            };
            menuSubSection.push(new MastheadBarButtonRecord(section));
          });
          profileMenuSection = {
            linkId: menuSection.linkId,
            linkName: menuSection.linkName,
            bevName: menuSection.anchorTagAttributes ? menuSection.anchorTagAttributes['data-bev-name'] : undefined,
            subMenuLinks: fromJS(menuSubSection)
          };
          profileMenuSection = new MastheadBarButtonRecord(profileMenuSection);
        } else {
          profileMenuSection = new NavigationItemRecord(getNavigationObject(menuSection, linkConfigMap));
        }

        menuSections.push(profileMenuSection);
      });
      profileBarButton = {
        linkId: menu.linkId,
        linkName: menu.linkName,
        bevName: menu.anchorTagAttributes ? menu.anchorTagAttributes['data-bev-name'] : undefined,
        subMenuLinks: menuSections
      };
    } else {
      profileBarButton = getNavigationObject(menu, linkConfigMap);
    }

    profileBarItems.push(new MastheadBarButtonRecord(profileBarButton));
  });
  return profileBarItems;
};

var parseDesktopNavigationConfig = function parseDesktopNavigationConfig(navigationPayload) {
  var navigationItems = {};
  var navigationBarItems = getNavigationBarItems(navigationPayload);
  var profileBarItems = getProfileBarItems(navigationPayload);
  navigationItems.navigationBarItems = navigationBarItems;
  navigationItems.profileBarItems = profileBarItems;
  return navigationItems;
};

export default parseDesktopNavigationConfig;